(() => {
  if (!window.KicksownSizeData?.charts) return;

  const chart = (label, systems, rows, displayLabels) => ({ label, systems, rows, ...(displayLabels ? { displayLabels } : {}) });
  const rows = (data) => data.map((r) => Object.fromEntries(r.map((value, index) => [data.systems[index], String(value)])));

  const setChart = (key, label, systems, data, displayLabels) => {
    data.systems = systems;
    window.KicksownSizeData.charts[key] = chart(label, systems, rows(data), displayLabels);
  };

  setChart('mizuno', 'Mizuno Women’s Size Guide', ['US M', 'US W', 'UK', 'EU', 'CM'], Object.assign([
    [4.5,6,3.5,36,22.5],[5,6.5,4,37,23],[5.5,7,4.5,37.5,23.5],[6,7.5,5,38,24],
    [6.5,8,5.5,38.5,24.5],[7,8.5,6,39,25],[7.5,9,6.5,40,25.5],[8,9.5,7,40.5,26],
    [8.5,10,7.5,41,26.5],[9,10.5,8,42,27],[9.5,11,8.5,42.5,27.5],[10,11.5,9,43,28],
    [10.5,12,9.5,44,28.5],[11,12.5,10,44.5,29],[11.5,13,10.5,45,29.5],[12,13.5,11,46,30],
    [13,14.5,12,47,31]
  ], {systems:['US M','US W','UK','EU','CM']}));

  setChart('asics', 'ASICS Women’s Size Guide', ['US M', 'US W', 'UK', 'EU', 'CM'], Object.assign([
    [3.5,5,2.5,35.5,22.5],[4,5.5,3,36,22.75],[4.5,6,3.5,37,23],[5,6.5,4,37.5,23.5],
    [5.5,7,4.5,38,24],[6,7.5,5,39,24.5],[6.5,8,5.5,39.5,25],[7,8.5,6,40,25.25],
    [7.5,8.5,6.5,40,25.5],[7.5,9,7,40.5,25.75],[8,9.5,7.5,41.5,26],[8.5,10,8,42,26.5],
    [9,10.5,8.5,42.5,27],[9.5,11,9,43.5,27.5],[10,11.5,9.5,44,28],[10.5,12,10,44.5,28.25],
    [11,12.5,10.5,45,28.5],[11.5,13,11,46,29],[12,13.5,11,46.5,29.5],[12.5,14,11.5,47,30]
  ], {systems:['US M','US W','UK','EU','CM']}));

  setChart('new-balance', 'New Balance Women’s Size Guide', ['US M', 'US W', 'UK', 'EU', 'CM'], Object.assign([
    [3,4.5,2.5,35,21],[3.5,5,3,35.5,21.5],[4,5.5,3.5,36,22],[4.5,6,4,37,22.5],
    [5,6.5,4.5,37.5,23],[5.5,7,5,38,23.5],[6,7.5,5.5,38.5,24],[6.5,8,6,39.5,24.5],
    [7,8.5,6.5,40,25],[7.5,9,7,40.5,25.5],[8,9.5,7.5,41.5,26],[8.5,10,8,42,26.5],
    [9,10.5,8.5,42.5,27],[9.5,11,9,43,27.5],[10,11.5,9.5,44,28],[10.5,12,10,44.5,28.5],
    [11,12.5,10.5,45,29],[11.5,13,11,45.5,29.5],[12,13.5,11.5,46.5,30],[12.5,14,12,47,30.5],
    [13,14.5,12.5,47.5,31],[14,15.5,13.5,49,32],[15,16.5,14.5,50,33],[16,17.5,15.5,51,34]
  ], {systems:['US M','US W','UK','EU','CM']}));

  setChart('puma', 'PUMA Women’s Size Guide', ['US M', 'US W', 'UK', 'EU', 'CM'], Object.assign([
    [4,5.5,3,35.5,22],[4.5,6,3.5,36,22.5],[5,6.5,4,37,23],[5.5,7,4.5,37.5,23.5],
    [6,7.5,5,38,24],[6.5,8,5.5,38.5,24.5],[7,8.5,6,39,25],[7.5,9,6.5,40,25.5],
    [8,9.5,7,40.5,26],[8.5,10,7.5,41,26.5],[9,10.5,8,42,27],[9.5,11,8.5,42.5,27.5],
    [10,11.5,9,43,28],[10.5,12,9.5,44,28.5],[11,12.5,10,44.5,29],[11.5,13,10.5,45,29.5],
    [12,13.5,11,46,30],[12.5,14,11.5,46.5,30.5],[13,14.5,12,47,31],[14,15.5,13,48.5,31.5]
  ], {systems:['US M','US W','UK','EU','CM']}));

  setChart('xtep-running', 'Xtep Running Women’s Size Guide', ['US M', 'US W', 'UK', 'EU', 'CM'], Object.assign([
    [3.5,5,2.5,35,21.5],[4,5.5,3,35.5,22],[4.5,6,3.5,36,22.5],[5,6.5,4,37,23],
    [5.5,7,4.5,37.5,23.5],[6,7.5,5,38,24],[6.5,8,5.5,39,24.5],[7,8.5,6,39.5,25],
    [7.5,9,6.5,40,25.5],[8,9.5,7,41,25.5],[8.5,10,7.5,41.5,26],[9,10.5,8,42,26.5],
    [9.5,11,8.5,43,27],[10,11.5,9,43.5,27.5],[10.5,12,9.5,44,28],[11,12.5,10,45,28.5]
  ], {systems:['US M','US W','UK','EU','CM']}));

  setChart('xtep', 'Xtep Basketball Women’s Size Guide', ['US M', 'US W', 'UK', 'EU', 'CM'], Object.assign([
    [3,4.5,2,34,21],[3.5,5,2.5,35,21.5],[4,5.5,3,35.5,22],[4.5,6,3.5,36,22.5],
    [5,6.5,4,37,23],[5.5,7,4.5,37.5,23.5],[6,7.5,5,38,24],[6.5,8,5.5,39,24.5],
    [7,8.5,6,39.5,25],[7.5,9,6.5,40,25.5],[8,9.5,7,41,26],[8.5,10,7.5,41.5,26.5],
    [9,10.5,8,42,27],[9.5,11,8.5,43,27.5],[10,11.5,9,43.5,28],[10.5,12,9.5,44,28.5],
    [11,12.5,10,45,29],[11.5,13,10.5,45.5,29.5],[12,13.5,11,46,29.5],[12.5,14,11.5,47,30],
    [13,14.5,12,47.5,30.5],[13.5,15,12.5,48,31],[14,15.5,13,49,31.5],[14.5,16,13.5,49.5,32],
    [15,16.5,14,50,32.5],[15.5,17,14.5,51,33]
  ], {systems:['US M','US W','UK','EU','CM']}));

  setChart('kailas', 'KAILAS Women’s Size Guide', ['US M', 'US W', 'UK', 'EU', 'CM'], Object.assign([
    [4,5.5,3.5,36,23],[4.5,6,4,36.5,23.3],[5,6.5,4.5,37,23.7],[5.5,7,5,37.5,24],
    [6,7.5,5.5,38,24.4],[6.5,8,6,39,25],[7,8.5,6,40,25.2],[7.5,9,6.5,41,25.5],
    [8,9.5,7,41.5,25.8],[8.5,10,7.5,42,25.8],[9,10.5,8,42.5,26.2],[9.5,11,8.5,43,26.5],
    [10,11.5,9,44,26.8],[10.5,12,9.5,44.5,27.5],[11,12.5,10,45,28.2],[11.5,13,10.5,46,28.8],
    [12,13.5,11,46.5,29.2],[12.5,14,11.5,47,29.5]
  ], {systems:['US M','US W','UK','EU','CM']}), {'CM':'CHN'});

  setChart('dowin', 'Dowin Women’s Size Guide', ['US M', 'US W', 'EU', 'CM'], Object.assign([
    [4.5,6,35,22.5],[5,6.5,36,23],[5.5,7,37,23.5],[6,7.5,38,24],[6.5,8,39,24.5],
    [7,8.5,40,25],[8,9.5,41,25.5],[8.5,10,41.5,26],[9,10.5,42,26.5],[9.5,11,43,27],
    [10,11.5,44,27.5],[11,12.5,45,28],[12,13.5,46,28.5]
  ], {systems:['US M','US W','EU','CM']}));

  setChart('volanti', 'Volanti Women’s Size Guide', ['US M', 'EU', 'CHN', 'CM'], Object.assign([
    [4,36,225,22.5],[4.5,36.5,230,23],[5,37,235,23.5],[5.5,38,240,24],[6,38.5,240,24],
    [6.5,39,245,24.5],[7,40,250,25],[7.5,40.5,255,25.5],[8,41,260,26],[8.5,42,265,26.5],
    [9,42.5,270,27],[9.5,43,275,27.5],[10,44,280,28],[10.5,44.5,285,28.5],[11,45,290,29],
    [11.5,45.5,295,29.5],[12,46,300,30],[12.5,47,305,30.5],[13,48,315,31.5],[13.5,49,320,32],
    [14.5,50,325,32.5]
  ], {systems:['US M','EU','CHN','CM']}), {'US M':'US(W)'});

  window.KicksownSizeData.version = '2026-08-24-womens';
})();
